<template>
  <p class="text-gray-400 text-lg">
    <slot />
  </p>
</template>
